import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, getToken } from '../api';
import { compressImage } from '../components/ProfilePrompt';

const SLOTS = 5;
const COLS = ['photo_url', 'photo_2_url', 'photo_3_url', 'photo_4_url', 'photo_5_url'];

export default function PhotosSettings() {
  const navigate = useNavigate();
  const fileRef = useRef(null);
  const [photos, setPhotos] = useState(Array(SLOTS).fill(null));
  const [saving, setSaving] = useState(false);
  const [activeSlot, setActiveSlot] = useState(null);
  const [mainPhotoError, setMainPhotoError] = useState(null);

  useEffect(() => {
    if (!getToken()) { navigate('/login'); return; }
    api.get('/profile').then(p => {
      setPhotos(COLS.map(col => p[col] || null));
    }).catch(() => {});
  }, [navigate]);

  const openPicker = (i) => {
    setActiveSlot(i);
    fileRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file || activeSlot === null) return;
    setMainPhotoError(null);
    setSaving(true);
    try {
      const base64 = await compressImage(file);

      if (activeSlot === 0) {
        const check = await api.post('/profile/photos/validate-main', { photo: base64 });
        if (!check.valid) {
          setMainPhotoError(check.reason || 'Your main photo must clearly show your face. Please use a headshot or close portrait.');
          setSaving(false);
          return;
        }
      }

      const next = [...photos];
      next[activeSlot] = base64;
      setPhotos(next);
      await api.post('/profile/photos', { photos: next });
    } catch {}
    setSaving(false);
  };

  const handleRemove = async (i, e) => {
    e.stopPropagation();
    const next = [...photos];
    next[i] = null;
    setPhotos(next);
    setSaving(true);
    try {
      await api.post('/profile/photos', { photos: next });
    } catch {}
    setSaving(false);
  };

  return (
    <div className="auth-screen" style={{ paddingTop: 60 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
        <button
          onClick={() => navigate('/settings')}
          style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 14, padding: 0 }}
        >
          ← Back
        </button>
        <div className="display-sm">Photos</div>
        {saving && <span style={{ fontSize: 12, color: 'var(--muted)', marginLeft: 'auto' }}>Checking…</span>}
      </div>

      <div style={{ fontSize: 12, color: 'var(--very-muted)', marginBottom: 32, lineHeight: 1.6 }}>
        Add up to 5 photos. The first photo is your main profile photo and must be a clear headshot.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {photos.map((url, i) => (
          <div
            key={i}
            onClick={() => openPicker(i)}
            style={{
              position: 'relative',
              aspectRatio: '3/4',
              background: '#111',
              borderRadius: 12,
              overflow: 'hidden',
              cursor: 'pointer',
              border: '1px solid #222',
            }}
          >
            {url ? (
              <>
                <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                <button
                  onClick={(e) => handleRemove(i, e)}
                  style={{
                    position: 'absolute', top: 8, right: 8,
                    background: 'rgba(0,0,0,0.65)', border: 'none', borderRadius: '50%',
                    width: 28, height: 28, color: '#fff', fontSize: 18, lineHeight: 1,
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  ×
                </button>
                {i === 0 && (
                  <div style={{
                    position: 'absolute', bottom: 8, left: 8,
                    background: 'rgba(0,0,0,0.65)', borderRadius: 4,
                    padding: '2px 8px', fontSize: 10, color: 'var(--gold)',
                    letterSpacing: 1, fontWeight: 600,
                  }}>
                    MAIN
                  </div>
                )}
              </>
            ) : (
              <div style={{
                width: '100%', height: '100%',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                color: 'var(--very-muted)',
              }}>
                <div style={{ fontSize: 28, lineHeight: 1, marginBottom: 8 }}>+</div>
                <div style={{ fontSize: 11 }}>Add photo</div>
              </div>
            )}
          </div>
        ))}
      </div>

      {mainPhotoError && (
        <div style={{ marginTop: 12, fontSize: 12, color: '#e05c5c', lineHeight: 1.5 }}>
          {mainPhotoError}
        </div>
      )}

      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
}
